<template>
<div class="container_nav fixed-top">
  <nav >
    <a href="/" class="navbar-brand">Daman</a>
    
    <ul class="nav-list">
      <li class="nav-item">
        <a href="#home" class="nav-link">Home</a>
      </li>
       <li class="nav-item">
        <a href="#about" class="nav-link">About</a>
      </li>
      <li class="nav-item">
        <a href="#skills" class="nav-link">Skills</a>
      </li>
      <li class="nav-item">
        <a href="#experience" class="nav-link">Experience</a>
      </li>
       <li class="nav-item">
        <a href="#projects" class="nav-link">Projects</a>
      </li>
       
       <li class="nav-item">
        <a href="#contact" class="nav-link">Contact</a>
      </li>
    </ul>
    <div class="hamburger">
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </div>
  </nav>
</div>
</template>
<script>
window.onload = function(){
    const selectElement = (element) => document.querySelector(element);
     selectElement('.hamburger').addEventListener('click',()=>{
                     selectElement('.nav-list').classList.toggle('active');
                     selectElement('.hamburger').classList.toggle('active');
                    

                 })
                 selectElement('.nav-list').addEventListener('click',()=>{
                     selectElement('.nav-list').classList.toggle('active')
                      selectElement('.hamburger').classList.toggle('active');
                 })
  

}
</script>
<style scoped>
/*


*/

*,
*::before,
*::after{
    margin: 0;
    padding: 0;
    box-sizing: inherit;
}

html{
  
    box-sizing: border-box;
}

body{
    width: 100%;
   
   
}



.container_nav{
    
    width: 100%;
    max-width: 120rem;
    margin: 0 auto;
    padding: 0 1.5rem;
    box-shadow: 2px 2px 5px  #002244;
    display:none;
   
    }

nav{
    display:none ;
        width: 100%;
        height: 3.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        
    }

 .navbar-brand{
        color:#FF033E;
         font-family: 'Kaushan Script', cursive;
         font-size:30px;
         margin-left: 30px;
         font-weight:600;
        display: flex;
    }
/*
.navbar-brand i{
    font-size: 4rem;
    color: #fff;
    margin: auto;

}*/

.nav-list{
    display: flex;
    list-style: none;
    margin-left:auto;
    

}

.nav-link{
    font-size: 1rem;
    font-weight:600;
    text-decoration: none;
    display: block;
    margin: 0 1rem;
    color: #fff;
    float:right;
    font-family: 'Noto Sans', sans-serif;

    /*
    transform: scale(0);
    transition: transform 650ms;
    
    
    */
}

.nav-item{
    position: relative;
    line-height: 1rem;
    transition-delay: .5s;
    /*
    visibility:hidden;
    */
   
}
.nav-link:hover{
    color:#FF033E;
}
/*
.nav-item::before{
    content: "";
    position: absolute;
    width: 80%;
    height: 2px;
    background-color:#FF033E;
    left: 15px;
    bottom: 0;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 650ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}*/

.nav-item:hover::before{
    transform: scaleX(1);
    transform-origin: left;
}



@media screen and (max-width:768px){
    .nav-list{
        width:100%;
        height:100vh;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        background-color:#2c3968;
        position:fixed;
        left:0;
        bottom:-100vh;
        transition:bottom 650ms;
        transition: all 650ms;
       
     
    }
    .navbar-brand{
        margin-left:15px !important;
    }
    .nav-link{
        font-size:24px !important;
        margin: 1rem auto; 
        font-family: 'Noto Sans', sans-serif;
    }
    .nav-link:hover{
        color:#FF033E;
    }
    
    .nav-list.active{
        bottom:0;
    }
    

    .nav-list.active .nav-link{
    transform:scale(1)
}
.nav-list.active .nav-item{
    visibility:visible;
    transition-delay: initial;
}
/*
.nav-list.active .nav-item:nth-child(1) .nav-link{
    transition-delay:.6s;
}
.nav-list.active .nav-item:nth-child(2) .nav-link{
    transition-delay:.5s;
}
.nav-list.active .nav-item:nth-child(3) .nav-link{
    transition-delay:.4s;
}
.nav-list.active .nav-item:nth-child(4) .nav-link{
    transition-delay:.3s;
}
.nav-list.active .nav-item:nth-child(5) .nav-link{
    transition-delay:.2s;
}
.nav-list.active .nav-item:nth-child(6) .nav-link{
    transition-delay:.1s;
}


/*
.nav-list .nav-item:nth-child(1) .nav-link{
    transition-delay: .1s;
}
.nav-list .nav-item:nth-child(2) .nav-link{
    transition-delay: .2s;
}
.nav-list .nav-item:nth-child(3) .nav-link{
    transition-delay: .3s;
}
.nav-list .nav-item:nth-child(4) .nav-link{
    transition-delay: .4s;
}
.nav-list .nav-item:nth-child(5) .nav-link{
    transition-delay: .5s;
}
.nav-list .nav-item:nth-child(6) .nav-link{
    transition-delay: .6s;
}
*/
.hamburger{
    width: 3.0rem;
    height: 1.3rem;
    position: relative;
    cursor: pointer;
    line-height: 5rem;
    z-index: 1500;
    
}


.hamburger .line{
    width: 100%;
    height: 2px;
    background-color: #fff;
    position: absolute;
    display: block;
    right: 0;
    transition: all 650ms;
}

.hamburger .line:nth-child(1){
    top: 0;
}

.hamburger .line:nth-child(2){
    top: 50%;
    margin-top: -1px;
    width: 2.6rem;
}

.hamburger .line:nth-child(3){
    top: 100%;
    margin-top: -2px;
    width: 2rem;
}

.hamburger.active .line:nth-child(1){
    transform: translateY(.7rem) rotate(45deg);
    width: 2rem;
}

.hamburger.active .line:nth-child(2){
    opacity: 0;
}

.hamburger.active .line:nth-child(3){
    transform: translateY(-.5rem) rotate(-45deg);
    width: 2rem;
}

}

</style>
